<template>
  <v-dialog v-model="dialogOpen" width="500" persistent>
    <v-card>
      <v-card-title>Are you sure?</v-card-title>
      <v-card-text>
        <v-row>
          <v-col>
            A monthly fee will be added for any additional numbers, are you sure?
          </v-col>
        </v-row>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" small @click="submit">CONFIRM</v-btn>
        <v-btn color="primary" small outlined @click="close">CANCEL</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
  export default {
    props: ['dialogOpen'],
    methods: {
      submit() {
        this.$emit('confirmed');
        this.close();
      },
      close() {
        this.$emit('close-dialog');
      },
    },
  }
</script>

<style lang="scss" scoped></style>
